export default "__VITE_ASSET__Ct3GK4oc__"